import React from 'react';
import * as styles from './average-star-rating-and-total.style';
import { jsx as ___EmotionJSX } from "@emotion/core";
var AverageRatingText = _ref => {
  var value = _ref.value,
    size = _ref.size;
  return ___EmotionJSX("span", {
    css: styles.avgRating(size)
  }, value.toFixed(1));
};
export { AverageRatingText };